import React, { useState } from 'react';
import Home from './Home';
import Checador from './Checador';

function Index({ onLogout, user }) {
    const [selectedTab, setSelectedTab] = useState('home'); // Estado para controlar qué tab está seleccionado
    const handleLogout = () => {
        onLogout();
    }

    return (
        <div className="min-h-screen bg-gray-200 flex flex-col justify-between">
            {/* Contenido Principal - Centrado */}
            {selectedTab === 'home' ? (
                <Home user={user} />) : (selectedTab === 'checker') ? (
                    <Checador user={user} />
                ) : <span>No view selected</span>}
            {/* Tabs Inferiores */}
            <div className="flex justify-between items-center bg-white p-4 shadow-lg fixed bottom-0 w-full">

                <HomeButton user={user} setSelectedTab={setSelectedTab} selectedTab={selectedTab} />
                <ChecadorButton user={user} setSelectedTab={setSelectedTab} selectedTab={selectedTab} />
                <button
                    className='w-full py-2 text-center text-lg text-gray-600'
                    onClick={() => handleLogout()}
                >
                    Cerrar Sesión
                </button>
            </div>
        </div>
    );
}

const HomeButton = ({ user, setSelectedTab, selectedTab }) => {
    return (
        <button
            className={`w-full py-2 text-center text-lg ${selectedTab === 'home' ? 'text-blue-600 border-b-2 border-blue-600' : 'text-gray-600'}`}
            onClick={() => setSelectedTab('home')}
        >
            Inicio
        </button>);
}

const ChecadorButton = ({ user, setSelectedTab, selectedTab }) => {
    let canUseChecker = (user.permissions && user.permissions.showAccesstTab);
    let is_guest = user.is_guest;
    return (<>{
        (!is_guest && canUseChecker) ?
            <button
                className={`w-full py-2 text-center text-lg ${selectedTab === 'checker' ? 'text-blue-600 border-b-2 border-blue-600' : 'text-gray-600'}`}
                onClick={() => setSelectedTab('checker')}
            >
                Checador
            </button> : <></>
    }</>);
}

export default Index;
